import React, { useEffect, useState } from 'react'
import { Range } from 'react-range'

import { v4 as uuidv4 } from 'uuid'

import { useActiveFilters } from 'src/zustand/stores/filters.store'

import styles from './RangeSlider.module.scss'

const MIN = 0
const MAX = 5000000

const RangeSlider = () => {
  const addAmountDepositFilter = useActiveFilters((state) => state.addAmountDepositFilter)
  const isReset = useActiveFilters((state) => state.isReset)
  const setResetFilters = useActiveFilters((state) => state.setResetFilters)

  const [values, setValues] = useState([MIN, MAX])

  useEffect(() => {
    if (isReset) {
      setValues([MIN, MAX])
      setResetFilters()
    }
  }, [isReset, setResetFilters])

  const handleClick = () => {
    addAmountDepositFilter([values[0], values[1]])
  }

  return (
    <div className={styles.range}>
      <p className={styles.range_title}>Сума вкладу старсів</p>

      <div className={styles.range_inputs}>
        <input type='number' value={values[0]} onChange={(e) => setValues([+e.target.value, values[1]])} />
        <span>-</span>
        <input type='number' value={values[1]} onChange={(e) => setValues([values[0], +e.target.value])} />
        <button type='button' onClick={handleClick}>
          OK
        </button>
      </div>

      <Range
        step={1}
        min={MIN}
        max={MAX}
        values={values}
        onChange={(newValues) => setValues(newValues)}
        renderTrack={({ props, children }) => (
          <div
            key={uuidv4()}
            {...props}
            style={{
              ...props.style,
              background: `linear-gradient(
              to right, 
              rgba(132, 56, 255, 0.1) ${((values[0] - MIN) / (MAX - MIN)) * 100}%, 
              #8438ff ${((values[0] - MIN) / (MAX - MIN)) * 100}%,
              #8438ff ${((values[1] - MIN) / (MAX - MIN)) * 100}%,
              rgba(132, 56, 255, 0.1) ${((values[1] - MIN) / (MAX - MIN)) * 100}%
            )`,
            }}
            className={styles.range_track}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => <div className={styles.range_thumb} {...props} key={uuidv4()} />}
      />
    </div>
  )
}

export default RangeSlider
